import React from 'react';
import OrganizationChartReact from './OrganizationChartReact';

const OrganizationChartIndex = () => {
  return (
    <>
      <OrganizationChartReact />
    </>
  );
};

export default OrganizationChartIndex;
